import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { errorAlert } from '../../../helpers/alerts';
import { addEmailReport } from '../../../redux/slices/report/emailReportSlice';
import { createEmailReportService } from '../../../services/report/emailReportService';
import EmailReportForm from '../../../components/report/EmailReportForm';

const CreateEmailReportScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handlerBack = () => {
    navigate(-1);
  };

  const handlerSubmit = async (data) => {
    createEmailReportService(data).then((response) => {
      dispatch(addEmailReport(response));
      navigate("/reportes/correos");
    }).catch((e) => errorAlert(e))
  }

  return (
    <EmailReportForm
      title={"Reportes por Correo"}
      goBack={handlerBack}
      submit={handlerSubmit}
    />
  )
}

export default CreateEmailReportScreen